import React from 'react';
import { useState } from 'react';
import { Checkbox, FormLabel, Select } from '@chakra-ui/react';

function ConvertToDeal() {
    const [isChecked, setIsChecked] = useState(false);
    const [contactRole, setContactRole] = useState([]);
    const [formData, setFormData] = useState(
        {
            contactRole: "",
            records: ""
        });
    const customStyle = {
        control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? 'silver' : 'rgb(93, 135, 255)',
            borderRadius: "20px",
            border: '0.5px solid rgb(196,196,196,0.5) !important'
        }),
    }
    const [records, setRecords] = useState(false);
    return (
        <div className='container py-3' >
            <div className='mb-5' style={{maxHeight:"95vh",overflow:'scroll'}}>
                <div>
                    <h5 style={{ color: '#ff176b' }}>Convert Lead</h5>
                    <div>
                        <div className='d-flex gap-2'>
                            <p style={{ fontWeight: '500' }}> Create New Account</p>
                            <p style={{ background: "rgb(235 233 233)", borderRadius: "7px" }}> Rangoni of florence</p>
                        </div>
                        <div className='d-flex gap-2'>
                            <p style={{ fontWeight: '500' }}> Create New Contact</p>
                            <p style={{ background: "rgb(235 233 233)", borderRadius: "7px" }}> Rangoni of florence Sample</p>
                        </div>
                        <div className='mt-3'>
                            <Checkbox defaultChecked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}>
                                Create a new Deal for this Account
                            </Checkbox>
                        </div>
                        {isChecked && <form>
                            <div className='row mt-4'>
                                <div className='col-lg-6 col-md-6 col-sm-12 mb-1'>
                                    <div className='search-by-title'>
                                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Amount' name='amount' />
                                    </div>
                                    <FormLabel className="small-label ps-3">Amount</FormLabel>
                                </div>
                            </div>
                            <div className='row '>
                                <div className='col-lg-6 col-md-6 col-sm-12 mb-1'>
                                    <div className='search-by-title'>
                                        <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Deal Name' name='dealName' />
                                    </div>
                                    <FormLabel className="small-label ps-3">Deal Name</FormLabel>
                                </div>
                            </div>
                            <div className='row '>
                                <div className='col-lg-6 col-md-6 col-sm-12 mb-1'>
                                    <div className='search-by-title'>
                                        <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Closing Date' name='closingDate' />
                                    </div>
                                    <FormLabel className="small-label ps-3">Closing Date</FormLabel>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12 mb-1'>
                                    <div className='search-by-title'>
                                        <select className=' rounded' name='stage' type='text' placeholder="stage" style={{ width: '100%', outline: 'none' }}  >
                                            <option value="Qualification">Qualification</option>
                                            <option value="Need Analysis">Need Analysis</option>
                                            <option value="Quote Create / Sent">Quote Create / Sent</option>
                                            <option value="Agreement Create">Agreement Create</option>
                                            <option value="Negotiation/Review">Negotiation/Review</option>
                                            <option value="Closed (Won)">Closed (Won)</option>
                                            <option value="Closed (Lost)">Closed (Lost)</option>
                                            <option value="Create So / Sent">Create So / Sent</option>
                                            <option value="Payment Received">Payment Received</option>
                                        </select>
                                    </div>
                                    <FormLabel className="small-label ps-3">Stage</FormLabel>
                                </div>
                            </div>
                            <div className='row '>
                                <div className='col-lg-6 col-md-6 col-sm-12 mb-1'>
                                    <div className='search-by-title'>
                                        <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Campaign Source' name='campaignSource' />
                                    </div>
                                    <FormLabel className="small-label ps-3">Campaign Source</FormLabel>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                                    <Select name='contactRole' options={contactRole} defaultValue={contactRole.find((item) => (item.value === formData?.contactRole))} onChange={(option) => { setFormData(prevFormData => ({ ...prevFormData, contactRole: option.value })) }} styles={customStyle} />
                                    <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Contact Role</FormLabel>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                                    <Select name='records' styles={customStyle} />
                                    <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Owner of the Records</FormLabel>
                                </div>
                            </div>
                        </form>}
                        <div className='gap-3 d-flex mt-3'>
                            <button className='create-button' >Convert</button>
                            <button variant='outline' mr={3} className="cancel-button">
                                Cancel
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default ConvertToDeal
